import { SVGProps } from "react"

const LifePreServer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.99637 18.2793C14.1071 18.2793 17.5 14.8847 17.5 10.7793C17.5 6.67388 14.0998 3.2793 9.98912 3.2793C5.88569 3.2793 2.5 6.67388 2.5 10.7793C2.5 14.8847 5.89294 18.2793 9.99637 18.2793ZM9.99637 6.96402C9.35114 6.96402 8.74215 7.12359 8.2129 7.41373L6.61793 5.81073C7.57492 5.15792 8.7349 4.78075 9.98912 4.78075C11.2579 4.78075 12.4323 5.16518 13.3966 5.82523L11.8088 7.42098C11.2651 7.13084 10.6489 6.96402 9.99637 6.96402ZM4.00797 10.7793C4.00797 9.53171 4.37772 8.37117 5.02296 7.41373L6.62518 9.00947C6.34244 9.53897 6.19019 10.141 6.19019 10.7793C6.19019 11.4321 6.34969 12.0486 6.64693 12.5854L5.05196 14.1811C4.39222 13.2164 4.00797 12.0486 4.00797 10.7793ZM13.8171 10.7793C13.8171 10.1483 13.6576 9.54622 13.3821 9.02398L14.977 7.42823C15.6223 8.38568 15.9993 9.53897 15.9993 10.7793C15.9993 12.0414 15.615 13.2092 14.9625 14.1739L13.3603 12.5709C13.6503 12.0414 13.8171 11.4248 13.8171 10.7793ZM10.0036 13.2817C8.6189 13.2817 7.50242 12.1647 7.50242 10.7793C7.50242 9.3939 8.6189 8.27688 10.0036 8.27688C11.3884 8.27688 12.5048 9.3939 12.5048 10.7793C12.5048 12.1647 11.3884 13.2817 10.0036 13.2817ZM9.99637 16.7851C8.75665 16.7851 7.60391 16.4079 6.64693 15.7696L8.24915 14.1666C8.7784 14.435 9.37289 14.5946 10.0036 14.5946C10.6344 14.5946 11.2361 14.435 11.7653 14.1594L13.3676 15.7551C12.4033 16.4079 11.2506 16.7851 9.99637 16.7851Z"
      fill="#26272E"
    />
  </svg>
)

export default LifePreServer
